module.exports = __webpack_public_path__ + "static/media/s_green_2.8d77a404.mp3";